import { render } from "./RoulleteOffers.vue?vue&type=template&id=f66bed2e&scoped=true"
import script from "./RoulleteOffers.vue?vue&type=script&lang=js"
export * from "./RoulleteOffers.vue?vue&type=script&lang=js"

import "./RoulleteOffers.vue?vue&type=style&index=0&id=f66bed2e&lang=css"
import "./RoulleteOffers.vue?vue&type=style&index=1&id=f66bed2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f66bed2e"]])

export default __exports__